import * as React from 'react';
import { Layout, Row } from 'antd';
import styled from 'styled-components';
import LandingImg from '../../../assets/images/VMIPO_HomescreenBanner.jpg';
import BannerImg from '../../../assets/images/Banner.png';
import ScreenHelper from '../../Styled/ScreenHelper';
import logoSvg from 'assets/images/logo.png';
import loginBackground from 'assets/images/background_ologin.jpg';
import Title from 'antd/lib/typography/Title';

const { Header, Content, Footer } = Layout;


export const BannerDiv = styled.div`
    height: 40em;
    background: url(${LandingImg});
    background-size: contain;
    background-position: center top;
    background-repeat: no-repeat;

@media only screen and (min-width: 992px) {
    height: 50em;
    /* width: 80%; */
    //margin-left: 160px;
    //margin-right: 160px;
}
    /*margin-bottom: 50px;*/

  /*width: 21em;*/
`;

export const DashboardTitle = styled.span`
    .dashboard-logo{
        width: 100%;

@media only screen and (max-width: 992px) {
    margin-bottom: 17.5em !important;
}
    }

 
`;

export const OfferingCardClasses = styled.div`
    .center-avatar {
        text-align: center;

        @media only screen and (min-width: 574px) {
            padding-right: 24px;
        }
    }

    .offering-status {
        width: 98px;
        height: 30px;
        border-radius: 70px;

        &.Closed {
            border: solid 1px #e28080;
            text-align: center;
            background-color: #fcf2f2;
            font-weight: bold;
            color: #c40002;
            line-height: 1.71;
        }

        &.Opened {
            border: solid 1px #78c487;
            background-color: #f1f9f2;
            text-align: center;
            color: #128710;
            font-weight: bold;
            line-height: 1.71;        
        }

        &.PreOpen {
            border: solid 1px #80bae2;
            background-color: #f2f8fc;
            text-align: center;
            color: #1174c4;
            font-weight: bold;
            line-height: 1.71;        
        }


        &.Suspended {
            border: solid 1px #d7da17;
            background-color: #fcffcb;
            text-align: center;
            color: #c2c500;
            font-weight: bold;
            line-height: 1.71;
        }
    }

@media only screen and (max-width: 574px) {
    .xs-no-padding {
        padding-left: 10px!important;
        padding-right: 10px!important;
    }

}
    
`;

export const STabCardDiv = styled.div`


    .ant-tabs-card > .ant-tabs-content {
  margin-top: -16px;
}

.ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  /*border-color: transparent;*/
  /*background: transparent;*/
}

.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}
`;




